/* ============================================================
   BEZEEN — UI behaviour
   Nav, accordion, reveal-on-scroll, PDP buy options,
   sticky CTA, exit-intent modal, mini-cart count
   ============================================================ */
(function () {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  /* Mobile nav */
  const toggle = $(".nav__toggle");
  const links = $(".nav__links");
  if (toggle && links) {
    toggle.addEventListener("click", () => {
      const open = links.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open);
    });
  }

  /* Accordion */
  $$(".accordion__item").forEach((item) => {
    const trigger = $(".accordion__trigger", item);
    const panel = $(".accordion__panel", item);
    if (!trigger || !panel) return;
    trigger.addEventListener("click", () => {
      const open = item.getAttribute("aria-expanded") === "true";
      item.setAttribute("aria-expanded", !open);
      panel.style.maxHeight = open ? null : panel.scrollHeight + "px";
    });
  });

  /* Reveal on scroll */
  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }),
    { threshold: 0.12 }
  );
  $$(".reveal").forEach((el) => io.observe(el));

  /* PDP buy options */
  $$(".buy-option").forEach((opt) => {
    opt.addEventListener("click", () => {
      $$(".buy-option").forEach((o) => o.classList.remove("selected"));
      opt.classList.add("selected");
      const input = $("input", opt);
      if (input) input.checked = true;
      const price = opt.dataset.price;
      const target = $("[data-buy-price]");
      if (price && target) target.textContent = price;
    });
  });

  /* Mini cart (in-memory demo) */
  let cart = 0;
  const cartCount = $("[data-cart-count]");
  $$("[data-add-cart]").forEach((btn) => {
    btn.addEventListener("click", () => {
      cart += 1;
      if (cartCount) cartCount.textContent = cart;
      btn.classList.add("added");
      const orig = btn.dataset.origLabel || btn.textContent;
      btn.dataset.origLabel = orig;
      btn.textContent = "✓";
      setTimeout(() => (btn.textContent = orig), 1100);
    });
  });

  /* Sticky mobile CTA */
  const sticky = $(".sticky-cta");
  if (sticky) {
    document.body.classList.add("has-sticky");
    const hero = $(".hero, .pdp");
    const onScroll = () => {
      const past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 400;
      sticky.classList.toggle("show", past);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* Exit-intent modal (once per session) */
  const modal = $("#exit-modal");
  if (modal) {
    const close = () => modal.classList.remove("open");
    $$("[data-close-modal]", modal).forEach((b) => b.addEventListener("click", close));
    modal.addEventListener("click", (e) => { if (e.target === modal) close(); });
    if (!sessionStorage.getItem("bezeen_exit")) {
      document.addEventListener("mouseout", (e) => {
        if (e.clientY <= 0 && !e.relatedTarget) {
          modal.classList.add("open");
          sessionStorage.setItem("bezeen_exit", "1");
        }
      });
    }
    // newsletter submit demo
    $$("form", modal).forEach((f) => f.addEventListener("submit", (e) => {
      e.preventDefault(); f.innerHTML = '<p style="padding:1rem 0">✓ Thank you — your code is on its way.</p>';
    }));
  }

  /* Generic newsletter demo */
  $$("form[data-newsletter]").forEach((f) => f.addEventListener("submit", (e) => {
    e.preventDefault();
    const msg = f.querySelector("[data-newsletter-msg]");
    if (msg) msg.hidden = false;
    f.querySelectorAll("input,button").forEach((el) => (el.disabled = true));
  }));

  /* Year in footer */
  $$("[data-year]").forEach((el) => (el.textContent = new Date().getFullYear()));

  /* Scroll progress bar */
  const prog = $(".scroll-progress");
  if (prog) {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      prog.style.transform = `scaleX(${max > 0 ? h.scrollTop / max : 0})`;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* Reveal variants */
  const io2 = new IntersectionObserver(
    (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io2.unobserve(e.target); } }),
    { threshold: 0.12 }
  );
  $$(".reveal-l, .reveal-r, .reveal-scale").forEach((el) => io2.observe(el));

  /* Hero slider */
  const slider = $("[data-slider]");
  if (slider) {
    const slides = $$(".slide", slider);
    const dotsWrap = $(".slider-dots", slider);
    let i = 0, timer;
    slides.forEach((_, n) => {
      const b = document.createElement("button");
      b.setAttribute("aria-label", "Slide " + (n + 1));
      b.addEventListener("click", () => go(n, true));
      dotsWrap && dotsWrap.appendChild(b);
    });
    const dots = dotsWrap ? $$("button", dotsWrap) : [];
    function go(n, manual) {
      slides[i].classList.remove("active");
      dots[i] && dots[i].removeAttribute("aria-current");
      i = (n + slides.length) % slides.length;
      slides[i].classList.add("active");
      dots[i] && dots[i].setAttribute("aria-current", "true");
      if (manual) restart();
    }
    function restart() { clearInterval(timer); timer = setInterval(() => go(i + 1), 6000); }
    $(".slider-arrow.next", slider)?.addEventListener("click", () => go(i + 1, true));
    $(".slider-arrow.prev", slider)?.addEventListener("click", () => go(i - 1, true));
    go(0); restart();
    slider.addEventListener("mouseenter", () => clearInterval(timer));
    slider.addEventListener("mouseleave", restart);
  }

  /* Marquee: duplicate track for seamless loop */
  $$(".marquee__track").forEach((t) => { t.innerHTML += t.innerHTML; });

  /* Card tilt (pointer) */
  if (window.matchMedia("(pointer:fine)").matches) {
    $$(".tilt").forEach((card) => {
      card.addEventListener("pointermove", (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = `perspective(800px) rotateY(${x * 7}deg) rotateX(${-y * 7}deg) translateY(-4px)`;
      });
      card.addEventListener("pointerleave", () => { card.style.transform = ""; });
    });
  }
})();
